import { Language } from "../../model/Language.js";
import { Pano } from "../Pano.js";
import { BaseControl, ControlPosition } from "./BaseControl.js";

export class ControlToggle extends BaseControl {
    constructor(pano: Pano) {
        super(pano);

        this.pano.addButton(
            {
                icon: {
                    active: "fal fa-pause pause",
                    default: "fal fa-play play"
                },
                tooltip: {
                    active: Language.resolve("Pause", "Pause"),
                    default: Language.resolve("Abspielen", "Play")
                },
                active: !this._video.paused,
                position: ControlPosition.LEFT,
                onInit: (item) => {
                    const updateToggleBtn = () => {
                        item.active = !this._video.paused;
                    };

                    pano.onChangeVideo.add((video) => {
                        item.visible = !!this.pano.current;
                    });

                    this._video.addEventListener("play", () => updateToggleBtn());
                    this._video.addEventListener("playing", () => updateToggleBtn());
                    this._video.addEventListener("pause", () => updateToggleBtn());
                    this._video.addEventListener("loadstart", () => updateToggleBtn());
                },
                onClick: (item) => {
                    if (this._video.paused) {
                        this.pano.play();
                    }
                    else
                        this._video.pause();
                }
            }
        );
    }
}